import {StoreType} from "../../../types/SharedTypes";

export const isLoggedInSelector = (state: StoreType) => {
  return state.sessionReducer.loggedIn;
}
